import { put } from "redux-saga/effects";
import { begin, end, pendingTask } from "react-redux-spinner";

import {
  IRemoveDevice,
  IApproveDevice,
  adminUserUpdateResponse
} from "../../admin.actions";
import AdminService from "../../admin.service";
import AdminFeedback from "../../admin.feedback";

export function* removeDevice(action: IRemoveDevice) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const { userId, deviceId } = action.payload;
    const adminService = new AdminService();
    const user = yield adminService.removeDevice(userId, deviceId);
    yield put(adminUserUpdateResponse(user, AdminFeedback.DEVICE_REMOVED));
  } catch (error) {
    yield put(
      adminUserUpdateResponse(error, AdminFeedback.DEVICE_REMOVE_FAILED)
    );
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* approveDevice(action: IApproveDevice) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const { userId, deviceId } = action.payload;
    const adminService = new AdminService();
    const user = yield adminService.approveDevice(userId, deviceId);
    yield put(adminUserUpdateResponse(user, AdminFeedback.DEVICE_APROVED));
  } catch (error) {
    yield put(
      adminUserUpdateResponse(error, AdminFeedback.DEVICE_APROVE_FAILED)
    );
  }
  yield put({ type: "SPINNER", [pendingTask]: end });
}
